export const designerAppState = {
	name: 'designerApp',
	component: 'mxShell',
	params: {
		appString: 'LayoutDesigner',
	},
	lazyLoad: async function (transition) {
		const $ocLazyLoad = transition.injector().get('$ocLazyLoad');

		const { shellAgentModule } = await import(/* webpackChunkName: "shell" */ '../Shell/shell');

		const { designerModule } = await import(/* webpackChunkName: "designer" */ './index.lazy');

		await $ocLazyLoad.inject(shellAgentModule.name, {}, true);
		await $ocLazyLoad.inject(designerModule.name);

		const designerAppInitializerService = transition.injector().get('mx.designer.DesignerAppInitializerService');
		await designerAppInitializerService.initDesignerApp();
	},
};

export const designerLayoutState = {
	url: '/designer/{type}/{context}',
	parent: designerAppState.name,
	name: 'designerLayout',
	component: 'mxLayoutDesigner',
};
